// Consulta a ANP (via proxy /api/anp) e traduz o retorno para o perfil do posto.
//
// A ANP responde por CNPJ; como o formulário já pede o CNPJ, ao detectar um
// posto buscamos lá e preenchemos sozinhos: nº de autorização (ANP), bandeira e
// combustíveis. O que não casar com nossas opções fica para a pessoa ajustar.

// distribuidora da ANP -> id de bandeira do nosso catálogo
function bandeiraId(distribuidora) {
  const d = (distribuidora || "").toUpperCase();
  if (!d) return "";
  const map = [
    [/VIBRA|PETROBRAS|\bBR\b/, "vibra"],
    [/IPIRANGA/, "ipiranga"],
    [/RAIZEN|RAÍZEN|SHELL/, "shell"],
    [/\bALE\b/, "ale"],
    [/\bSIM\b/, "sim"],
    [/RODO\s?[ÓO]?IL/, "rodoil"],
    [/PETROX/, "petrox"],
    [/SABB[ÁA]/, "sabba"],
    [/CHARRUA/, "charrua"],
    [/FEDERAL/, "federal"],
    [/TOTAL/, "total"],
    [/BRANCA/, "branca"],
  ];
  for (const [re, id] of map) if (re.test(d)) return id;
  return "outra";
}

// nome de produto da ANP -> id de combustível do nosso catálogo
function combustivelId(produto) {
  const p = (produto || "").toUpperCase();
  if (/GASOLINA.*ADITIV/.test(p)) return "gasolina_aditivada";
  if (/GASOLINA.*(PREMIUM|PODIUM|PODIUM|V-?POWER|GRID)/.test(p)) return "gasolina_premium";
  if (/GASOLINA/.test(p)) return "gasolina_comum";
  if (/ETANOL.*ADITIV/.test(p)) return "etanol_aditivado";
  if (/ETANOL|[ÁA]LCOOL/.test(p)) return "etanol";
  if (/DIESEL.*ADITIV/.test(p)) return "diesel_aditivado";
  if (/DIESEL.*S10/.test(p)) return "diesel_s10";
  if (/DIESEL.*S500/.test(p)) return "diesel_s500";
  if (/DIESEL/.test(p)) return "diesel_s500";
  if (/GNV|G[ÁA]S NATURAL/.test(p)) return "gnv";
  if (/ARLA/.test(p)) return "arla";
  return null;
}

export const fetchANP = async (cnpj) => {
  const digits = String(cnpj || "").replace(/\D/g, "");
  if (digits.length !== 14) return null;
  try {
    const r = await fetch(`/api/anp?cnpj=${digits}`);
    if (!r.ok) return null;
    const d = await r.json();
    return d && d.found ? d : null;
  } catch {
    return null;
  }
};

// Monta o patch do perfil do posto (registroAnp, bandeira, combustiveis)
export const anpParaPerfil = (anp) => {
  if (!anp) return {};
  const patch = {};
  if (anp.autorizacao) patch.registroAnp = anp.autorizacao;
  const b = bandeiraId(anp.distribuidora);
  if (b) patch.bandeira = b;
  const combs = Array.from(new Set((anp.produtos || []).map((x) => combustivelId(x.produto)).filter(Boolean)));
  if (combs.length) patch.combustiveis = combs;
  // A ANP já devolve distribuidora e bicos por produto — os mesmos campos da
  // Ficha Anexo II do Combustível. Tancagem fica de fora: a unidade não vem
  // declarada no retorno, e chutar litros onde pode ser m³ seria dado errado.
  if (anp.distribuidora) patch.distribuidora = anp.distribuidora;
  const bicos = (anp.produtos || []).reduce((s, x) => s + (Number(x.bicos) || 0), 0);
  if (bicos > 0) patch.qtdBicos = String(bicos);
  return patch;
};
